import { DATE_SUBMIT_FORMAT } from '../../../Common/settings/dateFormats'
import { IAPIUpdateAppointmentActivity } from '../../types/api'
import { IUpdateAppointmentData } from '../thunks/updateAppointmentActivity'

export const updateAppointmentActivityTransformer = (
  appointmentActivity: IUpdateAppointmentData,
): IAPIUpdateAppointmentActivity => ({
  starts_at: appointmentActivity.startsAt.format(DATE_SUBMIT_FORMAT),
  ends_at: appointmentActivity.endsAt.format(DATE_SUBMIT_FORMAT),
  person_id: appointmentActivity.personId,
  update_repeat_appointments: appointmentActivity.updateRepeatAppointments,
})
